import angular from 'angular';
import procedureListComponent from './procedure-list.component';
import procedureListConfig from './procedure-list.config';
import ProcedureListService from "./procedure-list.service";


let procedureListModule = angular.module('procedureList', [])

    .component('procedureList', procedureListComponent)
    .service('ProcedureListService', ProcedureListService)
    .config(procedureListConfig);

export default procedureListModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/procedure-list/procedure-list.js
 **/